const resolveAppEnv = () => {
  const shortEnv = (value) => {
    if (value === "prod" || value === "stage" || value === "uat" || value === "dev") {
      return value;
    }
    return null;
  };

  const fromCustomEnv = shortEnv(process.env.REACT_APP_CUSTOM_ENV);
  if (fromCustomEnv) return fromCustomEnv;

  const fromCustomUrl = shortEnv(process.env.REACT_APP_CUSTOM_URL);
  if (fromCustomUrl) return fromCustomUrl;

  const envValue = process.env.REACT_APP_CUSTOM_ENV || "";
  if (typeof envValue === "string" && envValue.includes("://")) {
    const host = envValue.replace(/^https?:\/\//, "").replace(/\/$/, "").toLowerCase();
    if (host.includes("stage.")) return "stage";
    if (host.includes("uat.")) return "uat";
    if (host.includes("dev.")) return "dev";
    if (host.includes("admin.") || host === "proteams.io") return "prod";
  }

  return "dev";
};

export const APP_ENV = resolveAppEnv();

if (typeof window !== "undefined") {
  console.log("[config] app env", {
    env: APP_ENV,
    port: window.location.port || "80",
  });
}

export const BaseUrl = (function() {
  if(APP_ENV === "prod") return 'https://us-central1-csmg-a0cd2.cloudfunctions.net/';
  else if(APP_ENV === "stage") return 'https://us-central1-stageptio.cloudfunctions.net/';
  else if(APP_ENV === "uat") return 'https://us-central1-uat-ptio.cloudfunctions.net/';
  else return 'https://us-central1-csmg-dev-dc546.cloudfunctions.net/';
}());

export const DOMAINURL = (function() {
  if(APP_ENV === "prod") return 'proteams.io';
  else if(APP_ENV === "stage") return 'stage.proteams.io';
  else if(APP_ENV === "uat") return 'uat.proteams.io';
  else return 'dev.proteams.io';
}());

export const APP_DOMAINURL = (function() {
  if(APP_ENV === "prod") return 'https://appview.proteams.io/auth/loginweb/';
  else if(APP_ENV === "stage") return 'https://appviewstage.proteams.io/auth/loginweb/';
  else if(APP_ENV === "uat") return 'https://appviewuat.proteams.io/auth/loginweb/';
  else return 'https://appviewdev.proteams.io/auth/loginweb/';
}());

export const ISSUE_DOMAIN = (function() {
  if(APP_ENV === "prod") return 'http://issues.proteams.io/';
  else if(APP_ENV === "stage") return 'http://issuesstage.proteams.io/';
  else if(APP_ENV === "uat") return 'http://issuesuat.proteams.io/';
  else return 'http://issuesdev.proteams.io/';  
}());

export const ROLES = {
  CLIENT: 'Client',
  EMPLOYEE: 'Employee',
  ADMIN: 'admin',
  SUPPORT: 'support',
};

export const EMP_ROLES = {
  CLIENT_TEAM: 'Client Team',
  ADMIN: 'Admin',
  GUEST: 'Guest',
  SUPPORT: 'Support'
};
export const COLLECTIONS = {
  USERS: 'users',
  EMPLOYEE: 'employees',
  CLIENT: 'clientsNew',
  TIMESHEETS: 'timesheets',
  ISSUES: 'issues',
};
